import styled from 'styled-components';

// in case that someone want to style Select components using styled-components
export const SSelectWrapper = styled.div``;
